import { ChipIcon } from "@heroicons/react/solid";
import React from "react";
import SkillCard from "../Molecules/SkillCard";
import HeroIcon from "../Atoms/HeroIcon";
import { useTranslation } from "react-i18next";

interface SkillsProps {}

const Skills: React.FC<SkillsProps> = () => {
  const { t } = useTranslation();

  return (
    <section id="skills">
      <div className="container px-5 py-10 mx-auto text-center">
        <div className="text-center mb-10">
          <HeroIcon Icon={ChipIcon} className="w-10 inline-block mb-4" />
          <h1 className="sm:text-4xl text-3xl font-medium title-font text-white mb-4">
            {t("skills.title")}
          </h1>
          <p className="text-base leading-relaxed  lg:w-3/4 mx-auto text-white">
            {t("skills.description")}
          </p>
        </div>
        <div className="justify-center flex flex-wrap lg:w-4/5 sm:mx-auto sm:mb-2 -mx-2">
          <SkillCard />
        </div>
      </div>
    </section>
  );
};

export default Skills;
